module.exports = __webpack_public_path__ + "static/avatar_andrey_malahov-a89ecbeb11d47a3de5c431d8dfe69dc3.jpg";